module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_6000.64826145.png";